import { styled } from '@mui/material'
import { CheckCircle, Circle } from '@phosphor-icons/react'
import { tokens } from 'ComponentLibrary/style-dictionary/output'

type ToggleProps = {
    isOn: boolean
    onToggle?: React.MouseEventHandler<SVGSVGElement>
    disabled?: boolean
}

export function Toggle({ onToggle, isOn, disabled = false }: ToggleProps) {
    const handleOnClick = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        if (disabled) {
            return
        }

        onToggle?.(event)
    }

    return isOn ? (
        <StyledCheckCircleIcon weight="fill" size={24} onClick={handleOnClick} $disabled={!!disabled} />
    ) : (
        <StyledCircleIcon size={24} onClick={handleOnClick} $disabled={!!disabled} />
    )
}

const sharedIconStyles = (disabled: boolean, defaultColor: string) => ({
    minWidth: '24px',
    color: disabled ? tokens.ColorIconDisabled : defaultColor,
    cursor: disabled ? 'default' : 'pointer',
    '&:hover:active': !disabled && {
        color: tokens.ColorSurfacePositiveBoldPressed,
        cursor: 'pointer',
    },
    '&:hover': !disabled && {
        color: tokens.ColorIconLinkHover,
    },
})

export const StyledCheckCircleIcon = styled(CheckCircle, {
    shouldForwardProp: (prop: string) => prop[0] !== '$',
})<{ $disabled: boolean }>(({ $disabled }) => ({
    ...sharedIconStyles($disabled, tokens.ColorIconPositive),
}))

export const StyledCircleIcon = styled(Circle, {
    shouldForwardProp: (prop: string) => prop[0] !== '$',
})<{ $disabled: boolean }>(({ $disabled }) => ({
    ...sharedIconStyles($disabled, tokens.ColorIconDisabled),
}))
